import { render } from "./Agents.vue?vue&type=template&id=680de7ba&scoped=true"
import script from "./Agents.vue?vue&type=script&lang=js"
export * from "./Agents.vue?vue&type=script&lang=js"

import "./Agents.vue?vue&type=style&index=0&id=680de7ba&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680de7ba"]])

export default __exports__